module.exports = __webpack_public_path__ + "static/media/transcription.593d761f.png";